/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Table_RefreshInputs */

const en_common_table_refresh = /** @type {(inputs: Common_Table_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

const zh_common_table_refresh = /** @type {(inputs: Common_Table_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Common_Table_RefreshInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_table_refresh = /** @type {((inputs?: Common_Table_RefreshInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Table_RefreshInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_table_refresh(inputs)
	return zh_common_table_refresh(inputs)
});
export { common_table_refresh as "common.table.refresh" }